<template>
  <div :class="{ 'plus-hidden': fileList.length >= limit}"
       class="upload-with-crop-wrap">
    <el-upload ref="upload"
               action="https://m.10010sy.cn/card_apply_core_test/v1/filestore/uploadfile"
               :accept="accept"
               list-type="picture-card"
               :file-list="fileList"
               :before-upload="beforeUpload"
               :http-request="uploadSectionFile"
               :on-remove="handleRemove"
               :on-preview="handlePreview">
      <i class="el-icon-plus"></i>
      <div slot="tip"
           class="el-upload__tip">
        上传图片不能超过{{ limit }}张，{{ cropperCheck ? '限制宽高比为'+fixedNumber[0] + ':' + fixedNumber[1] + '，' : '' }}大小不超过{{ isLt2M }}kb！已上传 <span style="color:#409EFF">{{ fileList.length }}</span> 张
      </div>
    </el-upload>
    <el-image-viewer v-if="showViewer"
                     :z-index="9999"
                     :on-close="closeViewer"
                     :initial-index="imageIndex"
                     :url-list="srcList" />
    <cropper-modal v-if="cropper"
                   :visible="visible"
                   :img="img"
                   :loading="loading"
                   :fixedNumber="fixedNumber"
                   :autoCropWidth="autoCropWidth"
                   :autoCropHeight="autoCropHeight"
                   @crop:cancel="cropCancel"
                   @crop:submit="cropSubmit"></cropper-modal>
  </div>
</template>
<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import CropperModal from './cropper-modal.vue'
export default {
  name: 'UploadWithCrop',
  components: { ElImageViewer, CropperModal },
  props: {
    isCompress: { type: Boolean, default: true },
    value: { type: Array, required: true, default () { return [] } },
    limit: { type: Number, default: 1 },
    accept: { type: String, default: 'image/*' },
    cropper: { type: Boolean, default: false },
    cropperCheck: { type: Boolean, default: true },
    fixedNumber: { type: Array, default () { return [1, 1] } },
    autoCropWidth: { type: Number, default: 200 },
    autoCropHeight: { type: Number, default: 200 },
    isLt2M: { type: Number, default: 2048 }
  },
  data () {
    return { loading: false, visible: false, img: null, uid: null, imageIndex: 0, showViewer: false }
  },
  computed: {
    plusStyle ({ autoCropWidth, autoCropHeight }) {
      return { width: autoCropWidth + 'px', height: autoCropHeight + 'px', lineHeight: autoCropHeight + 'px' }
    },
    fileList: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    srcList ({ fileList }) {
      return fileList.map(i => i.url)
    }
  },
  methods: {
    cropCancel () {
      this.visible = false
    },
    cropSubmit (file) {
      this.uploadFile(file.file)
    },
    uploadSectionFile ({ file }) {
      this.uploadFile(file)
    },
    uploadFile (file) {
      this.loading = true
      const form = new FormData()
      form.append('file', file)
      form.append('imageNotScale', this.isCompress ? 0 : 1)
      this.$$CommonApi.uploadfile(form)
        .then(res => {
          this.loading = false
          const { result, message, viewUrl, filepath } = res.data
          if (result === 0) {
            this.fileList.push({ url: viewUrl + filepath, name: file.name, status: 'success', uid: this.uid || file.uid })
            if (this.cropper && this.visible) {
              this.uid = null
              this.img = null
              this.visible = false
            }
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    beforeUpload (file) {
      if (file.size / 1024 > this.isLt2M) {
        this.$message.error('上传图片文件大小不能超过 2MB!')
        return false
      }
      if (this.cropperCheck) {
        return new Promise((resolve, reject) => {
          const img = new Image()
          img.src = URL.createObjectURL(file)
          img.onload = () => {
            const ratio = this.fixedNumber[0] / this.fixedNumber[1]
            if (img.width / img.height !== ratio) {
              this.$message.error(`图片推荐宽高比例为${this.fixedNumber[0]}:${this.fixedNumber[1]}`)
              setTimeout(() => {
                if (this.cropper) {
                  this.visible = true
                  this.img = URL.createObjectURL(file)
                  this.uid = file.uid
                }
                // eslint-disable-next-line prefer-promise-reject-errors
                reject()
              }, 1000)
            } else {
              resolve()
            }
          }
        })
      }
      return true
    },
    handleSuccess (res, file) {
      this.fileList.push({ ...file })
    },
    handleRemove (file) {
      const index = this.fileList.findIndex(i => i.uid === file.uid)
      index > -1 && this.fileList.splice(index, 1)
    },
    handlePreview (file) {
      const index = this.fileList.findIndex(i => i.uid === file.uid)
      this.imageIndex = index
      this.showViewer = true
    },
    closeViewer () {
      this.showViewer = false
    }
  }
}
</script>
<style lang="stylus" scoped>
.plus-hidden {
  /deep/ .el-upload {
    display: none;
  }
}

/deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  object-fit: contain;
}

.upload-with-crop-wrap /deep/ .el-upload--picture-card, .upload-with-crop-wrap /deep/ .el-upload-list__item {
  width: var(--custom-width,100px);
  height: var(--custom-height,100px);
  line-height: var(--custom-height,100px);
}

/deep/ .el-upload-list--picture-card {
  display: inline-block;

  .el-upload-list__item {
    vertical-align: top;
  }
}
</style>
